import Radium from 'radium';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waves from 'node-waves';
import { Scrollbars } from 'react-custom-scrollbars';
import { semanticColors, greyScaleColors } from './../../Globals/styles';

class SideBar extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount = () => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
    };
    componentDidUpdate = () => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
    };

    render() {
        const { onClose, title, style, children } = this.props;

        return (
            <div style={[styles.outerContainer, style]}>
                <div style={[styles.sideBarContainer]}>
                    <div style={styles.heading}>
                        <h2 style={[styles.title]}>
                            {title}
                            <i onClick={onClose} style={styles.closeCross} className="fa fa-times waves-icon" />
                        </h2>
                        <div style={styles.divider} />
                    </div>
                    <Scrollbars style={{ width: '100%', height: '100%' }}>
                        {children}
                    </Scrollbars>
                </div>
            </div>
        );
    }
}
var styles = {
    addEmployeeContainer: {
        position: 'absolute',
        top: '150px',
        left: '12px',
        right: '12px',
        height: '42px'
    },
    outerContainer: {
        position: 'absolute',
        top: '0',
        right: '0',
        height: '100%',
        paddingTop: '50px',
        width: '25%'
    },
    sideBarContainer: {
        position: 'relative',
        boxShadow: '-3px 5px 16px -2px rgba(0,0,0,0.54)',
        padding: '70px 12px 72px 12px',
        width: '100%',
        height: '100%',
        backgroundColor: semanticColors.default,
        borderRadius: '2px 0 0 2px'
    },
    heading: {
        position: 'absolute',
        top: '0',
        width: '100%',
        borderTop: '1px solid ' + semanticColors.mainBackground,
        left: '0',
        padding: '0 12px',
        borderRadius: '2px'
    },
    sideBarContainerNight: {
        backgroundColor: semanticColors.primaryDark
    },
    suggestInput: {
        height: '42px'
    },
    closeCross: {
        lineHeight: '30px',
        fontSize: '26px',
        width: '30px',
        height: '30px',
        float: 'right'
    },
    title: {
        fontWeight: '500',
        paddingTop: '4px',
        paddingBottom: '8px',
        lineHeight: '30px'
    },
    titleNight: {
        color: semanticColors.default
    },
    registerSettings: {
        margin: '0',
        paddingBottom: '12px'
    },
    nightDayContainer: {
        margin: '0'
    },
    date: {
        padding: '0px 7px 0px 0px',
        lineHeight: '35px'
    },
    dateNight: {
        color: semanticColors.default
    },
    closeButton: {
        cursor: 'pointer',
        color: greyScaleColors.greyDark,
        textAlign: 'right',
        fontSize: '26px'
    },
    DNButton: {
        height: '35px',
        fontSize: '20px',
        lineHeight: '1em'
    },
    dayBtn: {
        borderRadius: '2px 0px 0px 2px'
    },
    nightBtn: {
        borderRadius: '0px 2px 2px 0px'
    },
    nightDayActive: {
        backgroundColor: semanticColors.info,
        color: semanticColors.default
    },
    footerBtns: {
        width: '110px',
        float: 'left',
        marginBottom: '12px'
    },
    secondFooterBtn: {
        float: 'right'
    },
    resetLoading: {
        fontSize: '21px'
    },
    divider: {
        margin: '12px 0',
        borderTop: '1px solid ' + semanticColors.mainBackground
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        padding: '0 12px'
    },
    employeeContainer: {
        margin: '0',
        position: 'relative'
    }
}

export default Radium(SideBar)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/slideInBar.js